"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _WidgetContent = require("./WidgetContent");
Object.keys(_WidgetContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _WidgetContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WidgetContent[key];
    }
  });
});
